import { Component, ViewChild } from "@angular/core";
import { galleryTransition, fadeInOutAnimation } from "../../animations";
import { Catalog } from "../../data/catalog";
import { CatalogService } from "../../services/catalog.service";
import { Router } from "@angular/router";
import { OnInit } from "@angular/core";
import { WindowService } from "../../services/window.service";
import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { UserService } from "@app/services/user.service";
import * as _ from "underscore";
import { Plan } from "@app/data/user";
import * as lodash from "lodash";
import { UntypedFormControl } from "@angular/forms";
import { debounceTime } from "rxjs";

@Component({
  templateUrl: "./catalogs.list.component.html",
  animations: [galleryTransition, fadeInOutAnimation],
})
export class CatalogsListComponent implements OnInit {
  featuredCatalogs: Array<{ url: string; cover: string }> = [
    {
      url: "https://www.nowinstore.com/theme/assets/pdf/catalog_letternote.pdf",
      cover:
        "https:///www.nowinstore.com/theme/assets/img/landing/letternote.jpg",
    },
    {
      url: "https://www.nowinstore.com/theme/assets/pdf/catalog_oppositeoffar.pdf",
      cover:
        "https:///www.nowinstore.com/theme/assets/img/landing/oppositeoffar.jpg",
    },
    {
      url: "https://www.nowinstore.com/theme/assets/pdf/catalog_lilyval.pdf",
      cover: "https:///www.nowinstore.com/theme/assets/img/landing/lilyval.jpg",
    },
    {
      url: "https://www.nowinstore.com/theme/assets/pdf/catalog_isabellaraejewelry.pdf",
      cover:
        "https:///www.nowinstore.com/theme/assets/img/landing/isabellaraejewelry.jpg",
    },
    {
      url: "https://www.nowinstore.com/theme/assets/pdf/catalog_lovelyearthlings.pdf",
      cover:
        "https:///www.nowinstore.com/theme/assets/img/landing/lovelyearthlings.jpg",
    },
  ];
  keywordsFormControl = new UntypedFormControl();
  catalogs: Catalog[] = [];
  selectedCatalog: Catalog;
  animationInitialized: boolean = false;
  page: number = 0;
  isLoading: boolean = false;
  plan: Plan;
  platform: string;
  catalogsCount: number;
  limitReached: boolean;
  keywords: string = "";
  @ViewChild("deleteSupermodal") deleteSupermodalComponent: SupermodalComponent;

  constructor(
    private router: Router,
    private userService: UserService,
    private catalogService: CatalogService,
    private windowService: WindowService
  ) {}

  onSelect(catalog: Catalog): void {
    this.selectedCatalog = catalog;
  }

  getCatalogs(): void {
    this.isLoading = true;
    this.catalogService
      .getCatalogs(this.keywords, this.page)
      .then((catalogs) => {
        this.catalogs.push(...catalogs);
        this.isLoading = false;
      });
  }

  ngOnInit(): void {
    this.loadStatus();
  }

  ngAfterViewInit() {
    this.keywordsFormControl.valueChanges
      .pipe(
        debounceTime(50) // Apply debounceTime using pipe
      )
      .subscribe((newValue) => {
        this.catalogs = [];
        this.keywords = newValue;
        this.getCatalogs();
      });
  }

  loadStatus() {
    this.catalogService.getCatalogsCount().then((count) => {
      this.catalogsCount = count;
      this.userService.me().then((user) => {
        this.platform = user.accounts[0].type;
        this.plan = user.subscription.plan;
        this.limitReached = this.plan.limits.max_catalogs <= this.catalogsCount;
      });
    });
    this.page = 0;
    this.catalogs = [];
    this.getCatalogs();
  }

  openFeaturedCatalog(url): void {
    this.windowService.getNativeWindow().open(url);
  }

  copyCatalog(selectedCatalog, $event): void {
    this.loadStatus();
    this.catalogService.copy(selectedCatalog).then((catalog) => {
      this.catalogs.push(catalog);
      this.selectedCatalog = null;
      this.openCatalog(catalog);
    });
    $event.stopPropagation();
  }

  deleteCatalog() {
    this.catalogService.delete(this.selectedCatalog._id).then(() => {
      //TODO remove from list
      this.closeDeleteConfirmation();
      this.page = 0;
      this.loadStatus();
      this.catalogs.splice(this.catalogs.indexOf(this.selectedCatalog), 1);
    });
  }
  showDeleteConfirmation(catalog: Catalog, $event) {
    this.selectedCatalog = catalog;
    this.deleteSupermodalComponent.open();
    $event.stopPropagation();
  }

  closeDeleteConfirmation() {
    this.deleteSupermodalComponent.close();
  }

  openCatalog(catalog): void {
    this.windowService.getNativeWindow().document.location.href =
      "/designs/" + catalog._id + "/edit";
  }

  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  onScroll() {
    this.page += 1;
    this.getCatalogs();
  }

  createCatalog() {
    if (
      this.platform === "shopify" ||
      this.platform === "woocommerce" ||
      this.platform === "bigcommerce"
    ) {
      this.router.navigate(["/catalogs/add"]);
    } else {
      this.router.navigate(["/catalogs/create"]);
    }
  }
}
